import { Directive, ElementRef } from '@angular/core';
import { AuthProvider } from '@providers/auth/auth';

@Directive({
  selector: '[avatar]'
})
export class AvatarDirective {

  constructor(el: ElementRef, private authProvider: AuthProvider,) {
    this.getAvatar(el);

    this.authProvider.avatar.subscribe( (avatar: any) => {
      const url = `data:${avatar.mime};base64,${avatar.avatar}`;
      el.nativeElement.style.backgroundImage = `url(${url})`;
    });

  }

  async getAvatar(el: ElementRef) {
    let avatar = await this.authProvider.getAvatar()
    const url = `data:${avatar.mime};base64,${avatar.avatar}`;
    el.nativeElement.style.backgroundImage = `url(${url})`;
  }
}



// WEBPACK FOOTER //
// ./src/directives/avatar/avatar.ts